import React from 'react';

import { AppStateProvider } from './AppStateProvider';
import { JWTProvider } from './JWTProvider';

/**
 * Combined provider that wraps both JWT and App state providers
 * This ensures proper provider order and simplifies app setup
 */
export const AppProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <JWTProvider>
      <AppStateProvider>{children}</AppStateProvider>
    </JWTProvider>
  );
};

// Re-export hooks for convenience
export {
  useJWT,
  useJWTToken,
  useJWTValidity,
  useJWTServiceInfo,
  useJWTRedirects,
} from './JWTProvider';
export {
  useAppState,
  useServiceConfig,
  useTSPState,
  useFlowState,
} from './AppStateProvider';
